export default __webpack_public_path__ + "static/media/s3.c0afe45b.jpg";